<!--
* @program: tyh-oa 
* @author: ly
* @description: typeBoolean 
* @create: 2021-03-23 10:44
-->
<template>
    <div v-if="viewModel" style="text-align: center">
        <a-tag :color="presentColor">{{presentValue}}</a-tag>
    </div>
    <div v-else>
        <a-radio-group v-if="editable" v-model:value="record[column.dataIndex]" @change="columnTrigger" >
            <a-radio :value="false">{{column.boolTags?column.boolTags[0]:"否"}}</a-radio>
            <a-radio :value="true">{{column.boolTags?column.boolTags[1]:"是"}}</a-radio>
        </a-radio-group>
        <a-radio-group v-else v-model:value="record[column.dataIndex]" @change="columnTrigger" disabled>
            <a-radio :value="false">{{column.boolTags?column.boolTags[0]:"否"}}</a-radio>
            <a-radio :value="true">{{column.boolTags?column.boolTags[1]:"是"}}</a-radio>
        </a-radio-group>
    </div>
</template>

<script>
    import typeBase from "./typeBase";
    export default {
        name: "typeBoolean",
        mixins:[typeBase],
        computed:{
            presentValue(){
                if(this.column.boolTags){
                    return this.record[this.column.dataIndex]?this.column.boolTags[1]:this.column.boolTags[0]
                }
                else{
                    return this.record[this.column.dataIndex]?"是":"否"
                }
            },
            presentColor(){
                return this.record[this.column.dataIndex]?this.colors[1]:this.colors[0]
            }
        },
        data(){
            return{
                colors:["purple","cyan"]
            }
        }
    }
</script>

<style scoped>

</style>